import { createContext } from 'react';
// 将localcontext添加到window
let LocaleContext = window.__BWD_GLOBAL_LocalContext__;
if (!LocaleContext) {
    LocaleContext = createContext(undefined);
    window.__BWD_GLOBAL_LocalContext__ = LocaleContext;
}
// const LocaleContext = createContext<LocaleContextProps | undefined>(undefined);
export default LocaleContext;
